import { useQuery } from '@apollo/client/react';
import { GET_ORGANIZATION_BILLING_INFO } from '../queries/GetOrgBillingInfo';

// Define the expected shape of the query result
interface OrgBillingInfoResult {
  getOrgBillingInfo?: {
    orgBillingInfo?: any; // Replace 'any' with the actual type if available
  };
}

export function useOrganizationBillingInfo() {
  const { data, loading, error, refetch } = useQuery<OrgBillingInfoResult>(
    GET_ORGANIZATION_BILLING_INFO,
    {
      fetchPolicy: 'cache-first',
    }
  );

  return {
    data,
    loading,
    error,
    refetch,
    orgBillingInfo: data?.getOrgBillingInfo?.orgBillingInfo,
  };
}
